import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import useAdsManager from "../ads/useAdsManager";
import RoboticsResearchUpdate from "./RoboticsResearchUpdate";
import { clearRenderClock } from "../utils/renderClock";

export default function Layout({ children }) {
  const location = useLocation();
  const isAdminPath = location.pathname === "/admin" || location.pathname.startsWith("/admin/");
  useAdsManager();
  const [, setHydrated] = useState(false);

  useEffect(() => {
    clearRenderClock();
    setHydrated(true);
  }, []);

  if (isAdminPath) {
    return <div className="min-h-screen bg-neutral-50 text-ink">{children}</div>;
  }

  return (
    <div className="min-h-screen bg-[var(--page-bg)] text-ink">
      <a href="#main-content" lang="en" className="skip-link">Skip to content</a>
      <Header />
      <main id="main-content">
        {children}
        <RoboticsResearchUpdate />
      </main>
      <Footer />
    </div>
  );
}
